import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { RequestAuthInterceptor } from './interceptors/request-auth.interceptor';
import { ShowErrorsInterceptor } from './interceptors/show-errors.interceptor';
import { UnauthorizedInterceptor } from './interceptors/unauthorized.interceptor';

export const CORE_INTERCEPTORS: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: UnauthorizedInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ShowErrorsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestAuthInterceptor,
    multi: true,
  },
];
